import React from 'react';

import { Tooltip, withStyles } from '@material-ui/core';

import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

function CardTooltip({ message, children }) {
    const { contrastTheme } = useGlobal();

    const tooltip = {
        backgroundColor: contrastTheme ? '#000000' : '#FFFFFF',
        color: contrastTheme ? '#FFFFFF' : '#5b5b5f',
        boxShadow: contrastTheme ? '0px 8px 8px #FFFFFF' : '0px 8px 8px #65656548',
        fontFamily: 'Oxygen',
        fontSize: '14px',
        maxWidth: '284px',
        borderRadius: '8px',
        border: contrastTheme ? '1px solid #FFFFFF' : '1px solid #CCCCCC',
        borderBottom: 'none',
        lineHeight: '20px',
        padding: 16,
    };

    if (contrastTheme) {
        delete tooltip.boxShadow;
        delete tooltip.borderBottom;
    }

    const HtmlTooltip = withStyles(() => ({
        tooltip,
        arrow: {
            fontSize: 20,
            color: contrastTheme ? '#FFFFFF' : '#4A4A4A',
            '&::before': {
                background: contrastTheme ? '#000000' : '#FFFFFF',
                border: contrastTheme ? '1px solid #FFFFFF' : '1px solid #CCCCCC',
            },
        },
    }))(Tooltip);

    return (
        <HtmlTooltip title={message} placement="top" arrow enterTouchDelay={0}>
            <S.TooltipElement>{children}</S.TooltipElement>
        </HtmlTooltip>
    );
}

export default CardTooltip;
